import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import Typography from '@mui/material/Typography';

const useStyles = ({ height }) => ({
  header: {
    width: '100vw',
    height: `${height}px`,
    // background: '#373737',
    display: 'flex',
    justifyContent: 'space-between',
    position: 'sticky',
    top: 0,
    zIndex: 9999,
  },
  backButton: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    position: 'absolute',
    left: 0,
    height: `${height}px`,
    paddingLeft: '10px',
    textDecoration: 'none',
    color: 'blue',
  },

  titleContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    backgroundColor: '#fff',
  },
});

const MobileStatsPageHeader = ({ height }) => {
  const styles = useStyles({ height });
  const selection = useSelector(({ mainControls: { selection } }) => selection);
  const headerLabel = selection ? selection.name : 'Massachusetts';

  return (
    <header style={styles.header}>
      <Link to="/map" style={styles.backButton}>
        <ChevronLeftIcon />
        <Typography variant="h6" component="span">Map</Typography>
      </Link>
      <div id="header-center" style={styles.titleContainer}>
        <Typography variant="h6" component="h2" color="rgb(34, 70, 127)">{headerLabel}</Typography>
        <Typography variant="p" component="p" color="rgb(34, 70, 127)">{selection ? selection.level : ''}</Typography>
      </div>
    </header>
  );
};

export default MobileStatsPageHeader;
